import { Link } from 'react-router-dom';

export default function ForProfessionals() {
  return (
    <section className="relative py-8 md:py-20 bg-white overflow-hidden">
      <div className="relative mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="relative bg-[#FFF8F0] rounded-[24px] md:rounded-[40px] overflow-hidden">
          <div className="absolute top-20 right-10 w-32 h-32 border border-[#F49729]/20 rotate-45 z-[1]"></div>
          <div className="absolute top-40 right-20 w-20 h-20 border border-[#F49729]/10 rotate-12 z-[1]"></div>
          <div className="absolute bottom-32 left-1/3 w-3 h-3 bg-[#F49729] rounded-full z-[1]"></div>
          <div className="absolute top-1/3 right-1/4 w-2 h-2 bg-[#F49729]/60 rounded-full z-[1]"></div>

          <div className="relative z-10 grid lg:grid-cols-2 gap-0 lg:gap-12 items-center">
            {/* Image — top on mobile */}
            <div className="relative w-full h-[220px] sm:h-[300px] md:h-[380px] lg:h-[500px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=confident%20professional%20woman%20in%20modern%20workspace%20looking%20at%20laptop%20screen%20warm%20ambient%20lighting%20contemporary%20office%20design%20career%20growth%20concept%20elegant%20business%20attire%20soft%20golden%20hour%20light%20through%20windows%20professional%20portrait%20photography&width=720&height=560&seq=3&orientation=landscape"
                alt="Professional working"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>

            {/* Content */}
            <div className="px-5 sm:px-8 lg:px-16 py-8 md:py-16 lg:py-24">
              <div className="max-w-lg">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F49729]/10 border border-[#F49729]/30 rounded-full mb-5 md:mb-6">
                  <i className="ri-user-star-line text-[#F49729]"></i>
                  <p className="text-[#F49729] text-xs font-semibold tracking-[0.2em] uppercase">
                    For Professionals
                  </p>
                </div>
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111] leading-tight mb-4 md:mb-6">
                  Advance Your
                  <br />
                  <span className="text-[#F49729]">Career Globally</span>
                </h2>
                <p className="text-sm text-[#61616A] leading-relaxed mb-6 md:mb-8">
                  Unlock career opportunities with leading organizations worldwide. We connect you with
                  roles that match your expertise, aspirations, and long-term professional goals.
                </p>
                <div className="grid grid-cols-2 gap-2 md:gap-4 mb-7 md:mb-10">
                  {[
                    { icon: "ri-focus-3-line", text: "Personalized Career Matching" },
                    { icon: "ri-global-line", text: "Global Opportunities" },
                    { icon: "ri-presentation-line", text: "Interview Preparation" },
                    { icon: "ri-hand-coin-line", text: "Salary Negotiation" },
                  ].map((item, i) => (
                    <div key={i} className="flex items-center gap-2 p-2.5 bg-white/60 rounded-xl border border-[#F49729]/20 hover:border-[#F49729]/40 transition-colors">
                      <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#F49729]/20 text-[#F49729] flex-shrink-0">
                        <i className={`${item.icon} text-sm`}></i>
                      </span>
                      <span className="text-xs text-[#333] leading-snug">{item.text}</span>
                    </div>
                  ))}
                </div>
                <Link
                  to="/apply-talent"
                  className="inline-flex items-center px-6 py-3 text-xs font-semibold tracking-wider text-white bg-gradient-to-r from-[#F49729] to-[#e08820] rounded-full hover:shadow-[0_8px_30px_rgba(244,151,41,0.35)] transition-all cursor-pointer whitespace-nowrap"
                >
                  APPLY AS TALENT
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
